var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"integrations-activation-emails-list"},[_c('SectionWrapper',{attrs:{"title":_vm.title,"description":_vm.emptyState ? '' : _vm.$t((_vm.tPrefix + ".description")),"config":{
      descriptionMaxWidth: '684px',
      padding: '0px',
      background: 'transparent',
      titleFontSize: '24px'
    }}},[(!_vm.loading)?_c('div',[(_vm.emptyState)?_c('ActivationEmailsEmptyState',{on:{"click":function($event){_vm.emptyState = false}}}):_c('ActivationEmailList',{attrs:{"email":_vm.email},on:{"handle-change-enabled":_vm.handleChangeEnabled}})],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }